Promise.all([import('scripts/marmalade/classes/video-embed')]).then(_ref => {
  let [moduleVideoEmbed] = _ref;
  // Define the components
  const VideoController = moduleVideoEmbed.default;
  DomObserver.observe('[data-video]', blocks => {
    blocks.forEach(block => {
      const URL = block.getAttribute('data-video');
      const Video = new VideoController(URL);
      const load = () => {
        block.appendChild(Video.iframe);
      };
      block.addEventListener('click', e => e.preventDefault());
      block.addEventListener('click', load);
    });
  });
}).catch(error => {
  // Handle any errors that occur during import
  console.error('An error occurred while loading the modules:', error);
});